import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { RestService } from '../rest.service';
import { NbDialogRef, NbDialogService, NbToastrService } from '@nebular/theme';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { JsonEditorOptions, JsonEditorComponent } from 'ang-jsoneditor';
import { ComboStates } from '../../statesList';

@Component({
  selector: 'ngx-state-screen',
  templateUrl: './state-screen.component.html',
  styleUrls: ['./state-screen.component.scss'],
})
export class StateScreenComponent implements OnInit {
  @Input() inputObject: any;
  appRiskInfoObject: any = {};
  labelId: any;
  moduleName: any;
  titleName: any;
  data: any = {};
  MandatoryList: any = [];
  OptionalList: any = [];
  OpenList: any = [];
  labelList: any = [];
  optionalSearch: any = {};
  mandatorySearch: any = {};
  selectableSearch: any = {};
  q: number = 1;
  f: number = 1;
  w: number = 1;
  p: number = 1;
  urlSafe: SafeResourceUrl;
  eoDetailsList: any = [];
  cyberDetailsList: any = [];
  optDetailsList: any = [];
  minDetailsList: any = [];
  resultObject: any = {};
  editorOptions: any = new JsonEditorOptions();
  public object: any = {};
  @ViewChild(JsonEditorComponent, { static: false }) editor: JsonEditorComponent;
  irmJsonString: any;
  // tslint:disable-next-line: max-line-length
  constructor(public ref: NbDialogRef<StateScreenComponent>, private restService: RestService, private dialogService: NbDialogService, public sanitizer: DomSanitizer, public datepipe: DatePipe, private toastrService: NbToastrService) {
    this.editorOptions.mode = 'view';
    this.editorOptions.statusBar = false;
    this.editorOptions.expandAll = true;
  }
  rateFillingList: any[];
  getRateFillingByAppTypeAndState(data) {
    // tslint:disable-next-line: max-line-length
    this.restService.model('GetRateFillingByAppTypeAndStateAndApprovalFlag/' + data.appType + '/' + data.state + '/' + 'Yes').subscribe((response) => {
      this.rateFillingList = response;
      this.rateFillingList.forEach(element => {
        if (element.rateFillingId === data.rateFillingId) {
          this.appRiskInfoObject.effectiveDate = element.startDate;
          this.approvalDate = this.datepipe.transform(new Date(element.startDate).toLocaleDateString(), 'yyyy-MM-dd');
        }
      });
    });
  }



  approvalDate: any;
  onChangeRateFilling(appRiskInfoObject, rateFillingList) {
    this.resultObject = {};
    this.formListSearchClear();
    rateFillingList.forEach(element => {
      if (element.rateFillingId === appRiskInfoObject.rateFillingId) {
        this.appRiskInfoObject.effectiveDate = element.startDate;
        this.approvalDate = this.datepipe.transform(new Date(this.appRiskInfoObject.effectiveDate).toLocaleDateString(), 'yyyy-MM-dd');
      }
    });
    this.getRatingTablesAndFormListByStateAndAppTypeAndRateFillingId();
  }

  formListSearchClear() {
    this.optionalSearch = {};
    this.mandatorySearch = {};
    this.selectableSearch = {};
  }

  lobOrStateChange(data) {
    this.resultObject = {};
    this.formListSearchClear();
    this.restService.model('GetRateFillingByAppTypeAndStateAndApprovalFlag/' + data.appType + '/' + data.state + '/' + 'Yes').subscribe((response) => {
      this.rateFillingList = response;
      if (this.rateFillingList.length > 0) {
        data.rateFillingId = response[0].rateFillingId;
        data.effectiveDate = response[0].startDate;
        this.rateFillingList.forEach(element => {
          if (element.rateFillingId === data.rateFillingId) {
            this.approvalDate = this.datepipe.transform(new Date(element.startDate).toLocaleDateString(), 'yyyy-MM-dd');
          }
        });
        this.getRatingTablesAndFormListByStateAndAppTypeAndRateFillingId();
      } else {
        this.resultObject.errorFlag = true;
      }

    });
  }

  ngOnInit() {
    this.appRiskInfoObject = Object.assign({}, this.inputObject);
    this.appRiskInfoObject.effectiveDate = new Date(this.inputObject.effectiveDate);
    this.getLobMaster();
    if (this.appRiskInfoObject.globalHeaderAccess) {
      this.lobOrStateChange(this.appRiskInfoObject);
    } else {
      this.getRateFillingByAppTypeAndState(this.appRiskInfoObject);
      this.getRatingTablesAndFormListByStateAndAppTypeAndRateFillingId();
    }
  }
  lobMasterList: any = [];
  statesList: any = ComboStates;
  getLobMaster() {
    this.restService.model('GetLobMaster/' + '1').subscribe((response) => {
      this.lobMasterList = response;
    });
  }


  getStateDetails() {
    this.getEndorsementMandatoryList();
    this.getEndorsementOpenTypeList();
    this.getEndorsementOptionalList();
    if (this.appRiskInfoObject.appType === 'RESTD' || this.appRiskInfoObject.appType === 'ACSTD') {
      this.getIrmJson(this.appRiskInfoObject);
    }

    // tslint:disable-next-line: max-line-length

    // this.getLabelList('RESTD');
    // tslint:disable-next-line: max-line-length
    this.restService.model('GetReStdRatingTablesByStateAndAppTypeAndRateFillingId/' + this.appRiskInfoObject.state + '/' + this.appRiskInfoObject.appType + '/' + this.appRiskInfoObject.rateFillingId).subscribe((res) => {
      this.resultObject = res;
      this.eoDetailsList = res.eoDetails;
      this.cyberDetailsList = res.cyberDetails;
      this.optDetailsList = res.optDetails;
      this.minDetailsList = res.minDetails;
    });
  }


  getRatingTablesAndFormListByStateAndAppTypeAndRateFillingId() {
    // tslint:disable-next-line:max-line-length
    this.restService.postModel(this.appRiskInfoObject, 'GetRatingTablesAndFormListByStateAndAppTypeAndRateFillingId/').subscribe((res) => {
      if (res.ResponseFlag) {
        const responseData = res.ResponseData;
        this.resultObject = responseData;
        this.eoDetailsList = responseData.eoDetails;
        this.cyberDetailsList = responseData.cyberDetails;
        this.optDetailsList = responseData.optDetails;
        this.minDetailsList = responseData.minDetails;
        if (responseData.rateFillingDocumentId) {
          this.rateFillingDocumentId = responseData.rateFillingDocumentId;
          this.templateRateFillingFlag = true;
        } else {
          this.rateFillingDocumentId = 0;
          this.templateRateFillingFlag = false;
        }
        if (responseData.formListDocumentId) {
          this.formListDocumentId = responseData.formListDocumentId;
          this.templateFormsListFlag = true;
        } else {
          this.formListDocumentId = 0;
          this.templateFormsListFlag = false;
        }
        this.fileStatus = false;
        this.formFileStatus = false;

        if (this.appRiskInfoObject.appType === 'RESTD' || this.appRiskInfoObject.appType === 'ACSTD') {
          this.object = responseData.irm;
          this.irmJsonString = JSON.parse(this.object.jsonString);
        }
        this.MandatoryList = responseData.mandatoryEndorsement;
        this.OptionalList = responseData.optionalEndorsement;
        this.OpenList = responseData.selectableEndorsement;
      }
    });
  }

  getIrmJson(appRiskInfoObject) {
    // tslint:disable-next-line: max-line-length
    this.restService.model('GetIrmJsonByStateAndAppType/' + appRiskInfoObject.state + '/' + appRiskInfoObject.appType + '/' + appRiskInfoObject.rateFillingId).subscribe((response) => {
      if (Object.keys(response).length !== 0) {
        this.object = response;
        this.irmJsonString = JSON.parse(response.jsonString);
      }
    });
  }

  getEndorsementMandatoryList() {
    // tslint:disable-next-line: max-line-length
    this.restService.model('GetEndorsementNumberAndNameListByStateAndAppType/' + this.appRiskInfoObject.state + '/' + this.appRiskInfoObject.appType + '/' + '1' + '/' + this.datepipe.transform(new Date(this.appRiskInfoObject.effectiveDate).toLocaleDateString(), 'yyyy-MM-dd')).subscribe((response) => {
      this.MandatoryList = response.getEndorsementNumberAndNameList;
    });
  }

  getEndorsementOptionalList() {
    // tslint:disable-next-line: max-line-length
    this.restService.model('GetEndorsementNumberAndNameListByStateAndAppType/' + this.appRiskInfoObject.state + '/' + this.appRiskInfoObject.appType + '/' + '2' + '/' + this.datepipe.transform(new Date(this.appRiskInfoObject.effectiveDate).toLocaleDateString(), 'yyyy-MM-dd')).subscribe((response) => {
      this.OptionalList = response.getEndorsementNumberAndNameList;
    });
  }


  getEndorsementOpenTypeList() {
    // tslint:disable-next-line: max-line-length
    this.restService.model('GetEndorsementNumberAndNameListByStateAndAppType/' + this.appRiskInfoObject.state + '/' + this.appRiskInfoObject.appType + '/' + '3' + '/' + this.datepipe.transform(new Date(this.appRiskInfoObject.effectiveDate).toLocaleDateString(), 'yyyy-MM-dd')).subscribe((response) => {
      this.OpenList = response.getEndorsementNumberAndNameList;

    });
  }



  getLabelList(appType) {
    this.restService.model('GetLabelMasterForAlgorithm/' + '0' + '/' + appType).subscribe((response) => {
      // tslint:disable-next-line: no-console
      this.labelList = response;
    });

  }
  insertSpaces(string) {
    string = string.replace(/([a-z])([A-Z])/g, '$1 $2');
    string = string.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
    return string;
  }

  docButtonDisable: boolean = false;
  onPreviewScannedDoc(value, docId, previewModal) {

    this.docButtonDisable = true;
    if (value !== 0) {
      window.location.href = this.restService.baseUrl + 'DownloadDocument/' + docId.toString() + '/' + 'T';
      this.docButtonDisable = false;

    } else {
      this.restService.model('PreviewDocument/' + docId.toString() + '/' + 'T').subscribe((response) => {
        this.previewDialog(previewModal, response);
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(response.generatedPath);
      });
    }
  }

  endorsementName: any;
  endorsementId: any;
  previewDialog(d, s) {
    if (s.endorsementId != null) {
      this.endorsementName = s.formDetail;
      this.endorsementId = s.endorsementId;
    } else {
      this.endorsementName = s.documentName;

    }
    this.dialogService.open(d, {
      hasBackdrop: true,
      closeOnBackdropClick: false,
      hasScroll: true,
      // tslint:disable-next-line: no-console
    });
    this.docButtonDisable = false;

  }
  selectedTab: any = 'E&O Rating Tables';
  onChangeTab(event) {
    this.formListSearchClear();
    this.selectedTab = event.tabTitle;
  }

  checkObj(resultObject) {
    return resultObject !== undefined && resultObject !== null && Object.keys(resultObject).length > 0;
  }
  fileStatus: boolean = false;
  formFileStatus: boolean = false;

  handleFileInputddt(files: FileList, id, action) {
    this.fileStatus = action === 'RateFilling';
    this.formFileStatus = action === 'FormList';

    this.dttDoc = new FormData;
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        this.dttDoc.append('uploadFile_' + i, files[i]);
      }
      this.updateScannedApplication(id, action);
    }

  }

  scannedDocumentList: any = [];
  dttDoc: FormData;
  fileRangeStatus: boolean = false;
  buttonDisable: boolean = false;
  updateScannedApplication(id, action) {
    this.dttDoc.append('domainLetter', 'RF');
    this.dttDoc.append('folderName', 'STATESCREEN');
    this.dttDoc.append('appRiskInfoId', id);
    this.dttDoc.append('typeName', action);
    this.dttDoc.append('rateFilling', id);
    this.dttDoc.append('unique', id + action);

    this.restService.postModelWithFile(this.dttDoc, 'ApplicationDocumentUploadMultiple').subscribe((response) => {
      if (response.status) {
        this.showToast('Document Uploaded Successfully', 'success', 'arrow-circle-right-outline');
        this.fileRangeStatus = false;
        this.docButtonDisable = false;
        this.getRatingTablesAndFormListByStateAndAppTypeAndRateFillingId();

      } else {
        this.showToast('Uploaded Template is not valid', 'danger', 'alert-triangle-outline');
        this.docButtonDisable = false;
      }
    });
  }
  showToast(content, status, iconValue) {
    // tslint:disable-next-line: max-line-length
    this.toastrService.show('', content, { limit: 1, hasIcon: true, icon: iconValue, preventDuplicates: true, status });
    return true;
  }

  rateFillingDocumentId: any;
  formListDocumentId: any;
  templateRateFillingFlag: boolean = false;
  templateFormsListFlag: boolean = false;


  previewScannedDocuments(value, documentId, previewModal) {
    this.docButtonDisable = true;
    if (value !== 0) {
      window.location.href = this.restService.baseUrl + 'DownloadDocument/' + documentId.toString() + '/' + 'E';;
      this.docButtonDisable = false;

    } else {
      this.restService.model('PreviewDocument/' + documentId.toString() + '/' + 'E').subscribe((response) => {
        this.previewDialog(previewModal, response);
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(response.generatedPath);
      });
    }
  }

  checkObjNonEmpty(obj) {
    return Object.keys(obj).length !== 0;
  }
  deleteScannedDocument(s, id, action) {
    this.fileStatus = action === 'RateFilling';
    this.formFileStatus = action === 'FormList';
    this.restService.model('DeleteRateFillingOrFormListDocument/' + id + '/' + this.appRiskInfoObject.rateFillingId + '/' + action).subscribe((response) => {
      if (response.status) {
        if (action === 'RateFilling') {
          this.rateFillingDocumentId = 0;
          this.templateRateFillingFlag = false;
        }
        if (action === 'FormList') {
          this.formListDocumentId = 0;
          this.templateFormsListFlag = false;
        }
        this.fileStatus = false;
        this.formFileStatus = false;
        this.showToast('Document Deleted', 'danger', 'alert-triangle-outline');
        this.getRatingTablesAndFormListByStateAndAppTypeAndRateFillingId();


      }
    });
  }

}
